import { render, staticRenderFns } from "./TrancheForfaitTransportForm.vue?vue&type=template&id=58bebd4d&scoped=true&"
import script from "./TrancheForfaitTransportForm.vue?vue&type=script&lang=js&"
export * from "./TrancheForfaitTransportForm.vue?vue&type=script&lang=js&"
import style0 from "./TrancheForfaitTransportForm.vue?vue&type=style&index=0&id=58bebd4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bebd4d",
  null
  
)

component.options.__file = "TrancheForfaitTransportForm.vue"
export default component.exports